// /Users/adrian.leineweber/Development/gemini-test/client/src/hooks/useDebounce.js
import { useState, useEffect } from 'react';

/**
 * Debounces a value.
 * @param {any} value The value to debounce.
 * @param {number} delay The debounce delay in milliseconds.
 * @returns {any} The debounced value.
 */
function useDebounce(value, delay) {
  // State und Setter für den debounced Wert
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Setze einen Timer, um den debounced Wert nach der angegebenen Verzögerung zu aktualisieren
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Cleanup-Funktion: Lösche den Timer, wenn sich der Wert oder die Verzögerung ändert,
      // bevor der Timer abgelaufen ist, oder wenn die Komponente unmounted wird.
      // Dies verhindert, dass der alte Wert gesetzt wird, wenn sich der Wert schnell ändert.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Führe den Effekt nur dann erneut aus, wenn sich der Wert oder die Verzögerung ändert
  );

  return debouncedValue;
}

export default useDebounce;
